import {inject, Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivateFn, Router} from "@angular/router";
import { Observable, of } from "rxjs";
import { KeycloakService } from "./keycloak.service";

@Injectable({
  providedIn: "root",
})
export class PermissionRouteGuard  {
  constructor(
    private keycloakService: KeycloakService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const requiredRoles = route.data.requiredRoles;
    const userRoles = this.keycloakService.getRoles();

    if (requiredRoles && requiredRoles.length !== 0 && userRoles && userRoles.length !== 0) {
      if (requiredRoles.every((role: string) => userRoles.includes(role))) {
        return of(true);
      } else {
        this.router.navigate(["access-denied"], { skipLocationChange: true, replaceUrl : true });
        return of(false);
      }
    }
    return of(true);
  }
}

const canActivateWithPermission : CanActivateFn = (
    route: ActivatedRouteSnapshot
) => {
  return inject(PermissionRouteGuard).canActivate(route);
};
export { canActivateWithPermission };
